<!-- Search and Create Client Section -->
<div class="main-panel">
    <div class="d-flex pt-2">
        <div class="h-30p">
            <input
                type="text"
                class="form-control text-box-size shadow-sm client-search-input"
                placeholder="Search"
                [attr.id]="'gyan-client-textbox'"
                [attr.data-test]="'gyan-client-textbox'"
                [(ngModel)]="searchClientName"
                (keyup.enter)="SearchList()"
                (input)="onClearLoad()"
            />
            <div class="cursor-pointer clear-icon icon-pos" (click)="clearSearch()" *ngIf="searchClientName !== ''"></div>
        </div>

        <div class="form-control search-client"></div>

        <div class="cursor-pointer search-term-icon" (click)="clientSearchList()"></div>

        <div class="d-flex" class="submit-button">
            <button class="create-button d-flex" (click)="openClientModal(ClientModel)">
                <div class="icon-plus"></div>
                <div class="pl-3p">Create Client</div>
            </button>
        </div>
    </div>

    <!-- Loader Section -->
    <!-- <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center vh-100">
        <div class="p-5">
            <div class="d-flex">
                <div class="padding-summary">Loading...</div>
                <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading">
        <div class="d-flex justify-content-center align-items-center vh-100">
            <div class="p-5">
                <div class="d-flex">
                    <div class="padding-summary">Loading..</div>
                    <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="table-container">
        <div
            [ngClass]="{
                'height-table-div': clients.length == 10,
                'height-table-div-overflow': clients.length < 10 && clients.length <= 4,
            }"
        >
            <!--max-height: 67vh; margin-top: -5px; overflow: auto-->
            <table class="custom-table">
                <thead class="custom-table-head">
                    <tr>
                        <th class="col-4">Client Name</th>
                        <th class="col-5">Description</th>
                        <th class="col-1">Number Of Users</th>
                        <th class="col-2 text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let client of clients; let i = index">
                        <td title="{{ client.name }}" class="col-4">
                            {{ client.name.length > 45 ? (client.name | slice: 0 : 45) + '...' : client.name }}
                        </td>
                        <td title="{{ client.clients_details }}" class="col-5">
                            {{ client.clients_details.length > 50 ? (client.clients_details | slice: 0 : 50) + '...' : client.clients_details }}
                        </td>
                        <td class="col-1">{{ client.usersCount }}</td>
                        <td class="col-2 text-center">
                            <div class="actions-container">
                                <fa-icon (click)="togglePopup(i, $event)" class="p-1 cursor-pointer d-flex align-items-center" [icon]="faEllipsisV"> </fa-icon>
                                <div
                                    *ngIf="activePopupIndex === i"
                                    [ngClass]="{
                                        'popup-menu': !(clients.length >= 9 && i >= clients.length - 2),
                                        'popup-menu-bottom': clients.length >= 9 && i >= clients.length - 2,
                                    }"
                                >
                                    <div class="d-flex cursor-pointer popup-container" (click)="editClient(client, ClientModel)">
                                        <div class="edit-icon"></div>
                                        <div class="popup-item">Edit</div>
                                    </div>

                                    <!-- <div class="popup-item" (click)="deleteGroup(group)">Delete</div> -->
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!isLoading && clients?.length === 0">
                        <td colspan="4" class="no-user-text">No Clients available with searched text</td>
                    </tr>
                    <tr *ngIf="isLoading && isFirstTime">
                        <td colspan="4" class="text-center text-secondary">
                            <div class="d-flex justify-content-center align-items-center vh-45">
                                <div class="p-1">
                                    <div class="d-flex">
                                        <div class="padding-summary">Loading..</div>
                                        <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="clients.length > 0" class="pagination" class="d-flex justify-content-between align-items-center">
                <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                <div class="user-pagination pt-2 px-2">
                    <pagination
                        [totalItems]="totalItems"
                        [(ngModel)]="currentPage"
                        [maxSize]="5"
                        class="justify-content-center pagination mb-0 px-0"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                        firstText="&laquo;"
                        lastText="&raquo;"
                        [boundaryLinks]="true"
                        [rotate]="false"
                        (pageChanged)="onPageChanged($event)"
                    >
                    </pagination>
                </div>
            </div>

            <!-- <<<<<<<<<<<<<<<<<<<<<<< Modal Template >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>-->
            <ng-template #ClientModel let-modal>
                <div>
                    <div class="m-0">
                        <div class="modal-content text-center">
                            <div class="modal-header fw-600 create-ug-header">
                                <div *ngIf="clientid === 0">Create Client</div>
                                <div *ngIf="clientid > 0">Edit Client</div>
                                <div class="cursor-pointer btn-close close-form" (click)="modal.dismiss()"></div>
                            </div>
                            <div class="modal-body ug-form-body">
                                <!-- Form with Username and Password fields -->
                                <form class="form" (ngSubmit)="onSubmit(clientForm, modal, confirmationModal)" #clientForm="ngForm">
                                    <div class="mb-3">
                                        <div class="label-form">Client Name</div>
                                        <div class="loader-input-container">
                                            <input
                                                type="text"
                                                class="form-control shadow-sm ug-form-client"
                                                [readOnly]="clientid > 0"
                                                [disabled]="clientid > 0"
                                                id="clientName"
                                                [(ngModel)]="clientName"
                                                name="clientName"
                                                required
                                                placeholder="Enter Client Name"
                                                required
                                                minlength="1"
                                                (blur)="verifyClientName()"
                                                #clientNameField="ngModel"
                                                (keypress)="restrictInput($event)"
                                            />
                                            <div *ngIf="isLoading" class="spinner-container">
                                                <img class="loader-input-img" src="../../../assets/gifs/loader_wait.gif" alt="Loading..." />
                                            </div>
                                        </div>

                                        <div *ngIf="(clientNameField?.invalid && clientNameField?.touched) || isValidClientName">
                                            <div *ngIf="clientNameField?.errors?.['minlength']" class="validation-message">Name is required.</div>
                                            <div *ngIf="clientNameField?.errors?.['required']" class="validation-message">Name is required.</div>
                                            <div *ngIf="isValidClientName" class="validation-message">{{ isValidClientMsg }}</div>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <div class="label-form">Description</div>
                                        <input
                                            type="text"
                                            class="form-control shadow-sm ug-form-client"
                                            id="description"
                                            [(ngModel)]="description"
                                            name="description"
                                            placeholder="Enter Description"
                                            #discriptionField="ngModel"
                                        />
                                    </div>

                                    <div class="d-flex justify-content-end">
                                        <button *ngIf="clientid === 0" type="submit" [disabled]="isValidClientForm" class="create-btn">Create</button>
                                        <button *ngIf="clientid > 0" type="submit" [disabled]="isValidClientForm" class="create-btn">Save</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!-- <<<<<<<<<<<<<<<<<<<<<<<<<< Conformation modal>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
            <ng-template #confirmationModal let-modal>
                <div class="modal-header d-flex">
                    <h4 class="modal-title">Confirm Action</h4>
                    <button type="button" class="btn-close icon-close-admin" (click)="cancelAddUserGroup()"></button>
                </div>
                <div class="my-3 px-0 text-center">
                    <p class="d-flex justify-content-center align-items-center">Client is created successfully.<br />Do you want to add a new user group?</p>
                </div>
                <div class="text-center modal-footer delete-modal d-flex justify-content-center align-items-center">
                    <button class="btn modalactionbtn" (click)="confirmAddUserGroup()">Confirm</button>
                    <button class="btn modalactionbtn" (click)="cancelAddUserGroup()">Cancel</button>
                </div>
            </ng-template>
            <div *ngIf="showcreateandEditForm" class="overlay"></div>
        </div>
    </div>
</div>
